import { Store } from '@ngrx/store';

import { ProductLoaderOrigin } from '../../domain/enums/product-loader-origin.enum';

import { ProductPublicModels } from '@features/products/product';
import { ProductsArrayPublicCommands } from '@features/products/productsArray';
import { SharedProductPublicPorts } from '@shared/product';

export function addProductsToListUseCase(
    store: Store,
    productPaginationService: SharedProductPublicPorts.ProductPaginationPort,
    productsApi: ProductPublicModels.PublicProduct[],
    origin?: ProductLoaderOrigin
): void {
    if (origin === ProductLoaderOrigin.RELATEDS) {
        const productIds = productsApi.map(({ id }) => Number.parseInt(id));
        productPaginationService.addCategoryProducts(productIds);
    }

    // biome-ignore lint/performance/noAccumulatingSpread: <explanation>
    const productsArray = productsApi.reduce((acc, curr) => ({ ...acc, [Number.parseInt(curr.id)]: curr }), {});
    store.dispatch(ProductsArrayPublicCommands.LoadProductsArray({ productsArray }));
}
